<template>
    <div style="width: 95%;">
        <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Nombre establecimiento">
                    <b-form-input v-model="modificationLocal.nombre" :disabled="!hasPermision('E')"></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
              <b-form-group style="font-size: 1rem;" label="Solicitar eliminación">
                <b-row>
                    <b-col md="1" sm="2">
                        <switches
                        v-model="modificationLocal.eliminado"
                        :disabled="!hasPermision('E')"
                        style="margin-top: .5rem;"
                        color="red">
                        </switches>
                    </b-col>
                    <b-col>
                        <b-form-input v-if="!modification.eliminado" placeholder="Motivo" disabled></b-form-input>
                        <b-form-input v-else data-vv-scope='cambios_identificacion' v-validate='(modification.eliminado) ? "required": ""' v-model="modificationLocal.eliminado_motivo" placeholder="Motivo" :disabled="!hasPermision('E')" name="Motivo eliminación"></b-form-input>
                        <span class="error">{{ errors.first('cambios_identificacion.Motivo eliminación') }}</span>
                    </b-col>
                </b-row>
              </b-form-group>
            </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Categoria GN">
                  <b-form-select @input="loadTipo" v-model="modificationLocal.id_categoria_gn_comercial" :options="categoria_gn_comercial_options" class="mb-3" text-field="categoria_gn_comercial" value-field="id" :disabled="!hasPermision('E')"/>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Tipo establecimiento">

                   <multiselect
                    placeholder="Todas"
                    v-model="modificationLocal.id_tipo_establecimiento_comercial"
                    :options="tipo_establecimiento_gn_comercial_options"
                    label="tipo" track-by="id"
                    :disabled="tipo_establecimiento_gn_comercial_options.length===0 || !hasPermision('E')"
                    >
                  </multiselect>
                </b-form-group>
              </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código CNAE">

                    <multiselect
                    placeholder="Seleccionar una opción"
                    selectedLabel="Seleccionada"
                    deselect-label="Click o enter para deseleccionar"
                    select-label="Click o enter para seleccionar"
                    tag-placeholder="Seleccionar"
                    :custom-label="customLabelCNAE"
                    v-model="modificationLocal.codigo_cnae"
                    :options="cnae_options"
                    label="descripcion" track-by="id"
                    :disabled="!hasPermision('E')">
                  </multiselect>

                </b-form-group>
              </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Provincia">
                        <b-form-select @input="loadMunicipio" v-model="modificationLocal.provincia" :options="provincias_options" class="mb-3" text-field="entity_name" value-field="id" :disabled="!hasPermision('E')"/>
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Municipio">
                        <b-form-select @input="loadPoblacion" text-field="entity_name" value-field="id" v-model="modificationLocal.municipio" :options="municipio_options" class="mb-3" :disabled="municipio_options.length===0 || !hasPermision('E')"/>
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Población">
                        <b-form-select text-field="entity_name" value-field="id" v-model="modificationLocal.poblacion" :options="poblacion_options" class="mb-3" :disabled="poblacion_options.length===0 || !hasPermision('E')"/>
                    </b-form-group>
                </b-form>
              </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Tipo vía">
                        <b-form-select v-model="modificationLocal.tipo_via" :options="tipo_via_options" class="mb-3" text-field="name_type" value-field="name_type" :disabled="!hasPermision('E')"/>
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Nombre vía" class="autocomplete">
                        <b-form-input autocomplete="off" @input="loadNames" name="Nombre vía" v-model="modificationLocal.nombre_via" :disabled="!hasPermision('E')"></b-form-input>
                        <div v-if="show_names" class="autocomplete-items">
                          <div @click="setElement(element)" v-for="(element, index) in names_suggestions" v-bind:key="index">
                            {{element.street_type.name_type}} {{element.street_name}} ({{element.postal_code_address}})
                          </div>
                        </div>
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Número">
                        <b-form-input v-model="modificationLocal.numero" :disabled="!hasPermision('E')"></b-form-input>
                    </b-form-group>
            </b-form>
            </b-col>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Anexo">
                        <b-form-input v-model="modificationLocal.anexo" :disabled="!hasPermision('E')"></b-form-input>
                    </b-form-group>
            </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Dirección no estructurada">
                        <b-form-input v-model="modificationLocal.direccion_no_estructurada" :disabled="!hasPermision('E')"></b-form-input>
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Código postal">
                        <b-form-input v-model="modificationLocal.codigo_postal" :disabled="!hasPermision('E')"></b-form-input>
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Latitud">
                        <b-form-input v-model="modificationLocal.latitud" :disabled="!hasPermision('E')"></b-form-input>
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Longitud">
                        <b-form-input v-model="modificationLocal.longitud" :disabled="!hasPermision('E')"></b-form-input>
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                    <b-form-group style="font-size: 1rem;" label="Precisión coordenadas">
                        <b-form-select v-model="modificationLocal.id_precision_coordenada" :options="coordenadas_options" class="mb-3" text-field="tipo_precision" value-field="id" :disabled="!hasPermision('E')"/>
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-button @click="changeLocation">Modificar ubicación</b-button>
                <b-button v-if="modificationLocal.longitud" @click="getLocation">Ver ubicación modificada</b-button>
            </b-col>
        </b-row>
        <br>
        <b-row>
            <b-col style="text-align: left;" v-if="hasPermision('B') && modification.id_comercial">
                <b-button variant="danger" @click="deleteChanges">Eliminar</b-button>
                <b-button :disabled="modificationLocal.new" @click="clearChanges">Blanquear</b-button>
            </b-col>
            <b-col style="text-align: right;" v-if="hasPermision('E')">
                <b-button @click="cancelModification" :disabled="loading">Cancelar</b-button>
                <b-button @click="saveModification($event)" :disabled="loading">Guardar</b-button>
            </b-col>
        </b-row>
        <br>
        <div v-if="showAlert" class="div-full">
          <b-alert class="alert-class" show dismissible variant="danger" @dismissed="showAlert=false">
            {{alertText}}
          </b-alert>
        </div>
    </div>
</template>

<style scoped>
.div-full{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left:0;
  background-color: #0000006b;
}
.alert-class{
  position: relative;
  top: 50%;
  width: 75%;
  left: 15%;
}
</style>

<script>
import Switches from 'vue-switches';
var debounce = require('debounce');

export default {
  name: 'ComercialCambios',
  inject: {
    $validator: '$validator'
  },
  props: ['modification', 'permisos'],
  components: {
    Switches
  },
  data () {
    return {
      modificationLocal: this.modification,
      showAlert: false,
      alertText: '',
      tipo_establecimiento_gn_comercial_options: [],
      municipio_options: [],
      poblacion_options: [],
      categoria_gn_comercial_options: [],
      provincias_options: [],
      tipo_via_options: [],
      coordenadas_options: [],
      cnae_options: [],
      names_suggestions: [],
      loading: false,
      show_names: false,
      clickHappened: false
    };
  },
  mounted: function () {
    Promise.all([
      this.$http.get('geoprovincia/', {params: {not_paginated: true}}),
      // this.$http.get('municipios/', {params: {not_paginated: true}}),
      // this.$http.get('poblaciones/', {params: {not_paginated: true}}),
      this.$http.get('categorias_gn_comercial/', {params: {not_paginated: true}}),
      this.$http.get('tipos_vias/', {params: {not_paginated: true}}),
      this.$http.get('precision_coordenadas/', {params: {not_paginated: true}}),
      this.$http.get('cnae/', {params: {not_paginated: true}})
      // this.$http.get('tipos_comerciales/', {params: {not_paginated: true}})
    ]).then(results => {
      this.provincias_options = [{id: null, entity_name: ''}].concat(results[0].data);
      this.categoria_gn_comercial_options = [{id: null, categoria_gn_comercial: ''}].concat(results[1].data);
      this.tipo_via_options = [{id: null, name_type: ''}].concat(results[2].data);
      this.coordenadas_options = [{id: null, tipo_precision: ''}].concat(results[3].data);
      // this.cnae_options = [{id: null, descripcion: ''}].concat(results[4].data).map(e => e.id + ' - ' + e.descripcion)

      this.cnae_options = [{id: null, descripcion: ''}].concat(results[4].data);
      // this.cnae_options = this.cnae_options.map(function (e) {
      //   e.descripcion = e.id + ' - ' + e.descripcion
      //   return e
      // })

      this.categoria_gn_comercial_options.map(v => {
        if (v.categoria_gn_comercial === 'CLIENTES COMERCIALES') {
          v.disabled = true;
        }
        return v;
      });

      this.loadTipo();
      this.loadMunicipio();
    });
  },
  methods: {

    customLabelCNAE: function (opt) {
      return opt.id + ' - ' + opt.descripcion;
    },
    loadNames: debounce(function (value) {
      if (value && !this.clickHappened && this.municipio_options) {
        var municipio = this.municipio_options.find(e => e.id === this.modificationLocal.municipio).zeus_codigo_municipio_ine;
        this.$http.get('streets/', {params: {zeus_codigo_municipio_ine: municipio, direccion__icontains: value.toUpperCase()}}).then(result => {
          this.names_suggestions = result.data.results;
          this.show_names = true;
        });
      } else {
        this.show_names = false;
      }
    }, 250),
    setElement: function (value) {
      if (value.street_name) {
        this.$set(this.modificationLocal, 'nombre_via', value.street_name);
      }
      if (value.postal_code_address) {
        this.$set(this.modificationLocal, 'codigo_postal', value.postal_code_address);
      }
      if (value.street_type) {
        this.$set(this.modificationLocal, 'tipo_via', value.street_type.name_type);
      }
      if (value.zeus_codigo_poblacion_ine) {
        var p = this.poblacion_options.find(e => e.zeus_codigo_poblacion_ine === value.zeus_codigo_poblacion_ine);
        this.$set(this.modificationLocal, 'poblacion', p.id);
      }

      this.show_names = false;
      this.clickHappened = true;

      var th = this;
      setTimeout(() => {
        th.clickHappened = false;
      }, 400);
    },
    clearChanges: function () {
      this.loading = true;

      this.$http.post('historico_correccion_comercial/', this.modificationLocal);

      this.modificationLocal = {
        'new': false,
        'anexo': null,
        'codigo_cnae': null,
        'codigo_municipio_zeus': null,
        'codigo_poblacion_zeus': null,
        'codigo_postal': null,
        'codigo_provincia_zeus': null,
        'codigo_via': null,
        'create_date': this.modificationLocal.create_date,
        'create_user': this.modificationLocal.create_user,
        'direccion_no_estructurada': null,
        'eliminado': false,
        'eliminado_create_date': null,
        'eliminado_create_user': null,
        'eliminado_motivo': null,
        'geom': null,
        'id_categoria_gn_comercial': null,
        'id_comercial': this.modificationLocal.id_comercial,
        'id_precision_coordenada': null,
        'id_tipo_establecimiento_comercial': null,
        'latitud': null,
        'longitud': null,
        'municipio': null,
        'nombre': null,
        'nombre_via': null,
        'numero': null,
        'poblacion': null,
        'provincia': null,
        'resto_direccion': null,
        'tipo_via': null,
        'update_date': null,
        'update_user': null
      };
      this.$parent.modification = this.modificationLocal;

      this.$http.put('correccion_comercial/' + this.modificationLocal.id_comercial + '/', this.modificationLocal).then(result => {
        alert('Guardado con éxito!');
        this.modificationLocal = result.data;
        this.$parent.modification = this.modificationLocal;
        this.loading = false;
      });
    },
    deleteChanges: function () {
      this.validDelete().then(result => {
        if (result.data.status) {
          this.$http.delete('comercial/' + this.modificationLocal.id_comercial + '/').then(result => {
            alert('Eliminado con éxito!');
            this.loading = false;
            // this.$parent.$parent.$parent.close()
            this.$emit('close');
          });
        } else {
          this.alertText = 'Este comercial no puede ser eliminado porque tiene visitas i/o multimedia.';
          this.showAlert = true;
        }
      });
    },
    validDelete: function () {
      return this.$http.get('comercial/' + this.modificationLocal.id_comercial + '/validDelete/');
    },
    setLocation: function (latlng) {
      this.modificationLocal.latitud = latlng.lat;
      this.modificationLocal.longitud = latlng.lng;
    },
    changeLocation: function () {
      this.$emit('changeLocation', this.modificationLocal);
    },
    getLocation: function () {
      this.$emit('getLocation', this.modificationLocal);
    },
    hasPermision: function (p) {
      return this.permisos['COMERCIAL'][p];
    },
    loadTipo: function () {
      if (this.modificationLocal.id_categoria_gn_comercial) {
        this.$http.get('tipos_comercial/', {params: {not_paginated: true, id_categoria_gn_comercial: this.modificationLocal.id_categoria_gn_comercial}}).then(result => {
          this.tipo_establecimiento_gn_comercial_options = [{id: null, tipo: ''}].concat(result.data);

          let matchedTipo = this.tipo_establecimiento_gn_comercial_options.filter(v => v.id === this.modificationLocal.id_tipo_establecimiento_comercial);
          if (matchedTipo.length > 0) {
            this.modificationLocal.id_tipo_establecimiento_comercial = matchedTipo[0];
          }
        });
      } else {
        this.tipo_establecimiento_gn_comercial_options = [];
      }
    },
    loadMunicipio: function () {
      if (this.modificationLocal.provincia) {
        this.$http.get('geomunicipio/', {params: {not_paginated: true, cod_gas_provincia: this.modificationLocal.provincia}}).then(result => {
          this.municipio_options = [{id: null, entity_name: ''}].concat(result.data);
          if (this.municipio_options.findIndex(e => e.id === this.modificationLocal.municipio) < 0) {
            this.modificationLocal.municipio = null;
          }
          this.loadPoblacion();
        });
      } else {
        this.municipio_options = [];
        this.modificationLocal.municipio = null;
      }
    },
    loadPoblacion: function () {
      if (this.modificationLocal.municipio) {
        this.$http.get('geopoblacion/', {params: {not_paginated: true, cod_gas_municipio: this.modificationLocal.municipio}}).then(result => {
          this.poblacion_options = [{id: null, entity_name: ''}].concat(result.data);
          if (this.poblacion_options.findIndex(e => e.id === this.modificationLocal.poblacion) < 0) {
            this.modificationLocal.poblacion = null;
          }
        });
      } else {
        this.poblacion_options = [];
        this.modificationLocal.poblacion = null;
      }
    },
    saveModification: function (event, triggeredExternally = false) {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario');
        } else {
          // if (this.modificationLocal.id_tipo_establecimiento_comercial !== undefined && this.modificationLocal.id_tipo_establecimiento_comercial !== null) {
          //   this.modificationLocal.id_tipo_establecimiento_comercial = this.modificationLocal.id_tipo_establecimiento_comercial.id
          // }

          // if (this.modificationLocal.codigo_cnae !== undefined && this.modificationLocal.codigo_cnae !== null) {
          //   this.modificationLocal.codigo_cnae = this.modificationLocal.codigo_cnae.id
          // }

          if (!triggeredExternally) { console.log('EMITTING CAMBIOS'); this.$emit('triggerComercialSave', 'cambios'); }

          this.loading = true;
          if (this.modificationLocal.new) {
            this.$http.post('correccion_comercial/', this.modificationLocal).then(result => {
              alert('Guardado con éxito!');
              this.modificationLocal = result.data;
              this.$parent.modification = this.modificationLocal;
              this.$parent.modification.new = false;
              this.modificationLocal.new = false;
              this.loading = false;
              this.$emit('comercialSaved');
            });
          } else {
            let fieldsUsedInCambios = {
              nombre: this.modificationLocal['nombre'],
              eliminado: this.modificationLocal['eliminado'],
              eliminado_motivo: this.modificationLocal['eliminado_motivo'],
              id_categoria_gn_comercial: this.modificationLocal['id_categoria_gn_comercial'],
              id_tipo_establecimiento_comercial: this.modificationLocal['id_tipo_establecimiento_comercial'],
              codigo_cnae: this.modificationLocal['codigo_cnae'],
              provincia: this.modificationLocal['provincia'],
              municipio: this.modificationLocal['municipio'],
              poblacion: this.modificationLocal['poblacion'],
              tipo_via: this.modificationLocal['tipo_via'],
              nombre_via: this.modificationLocal['nombre_via'],
              numero: this.modificationLocal['numero'],
              anexo: this.modificationLocal['anexo'],
              direccion_no_estructurada: this.modificationLocal['direccion_no_estructurada'],
              codigo_postal: this.modificationLocal['codigo_postal'],
              latitud: this.modificationLocal['latitud'],
              longitud: this.modificationLocal['longitud'],
              id_precision_coordenada: this.modificationLocal['id_precision_coordenada'],
              new: this.modificationLocal['new']
            };

            this.$http.patch('correccion_comercial/' + this.modificationLocal.id_comercial + '/', fieldsUsedInCambios).then(result => {
              alert('Guardado con éxito!');
              this.modificationLocal = result.data;
              // this.$parent.modification = this.modificationLocal
              this.loading = false;
              this.$emit('comercialSaved');
            });
          }
        }
      });
    },
    cancelModification: function () {
      this.loading = true;
      this.$http.get('correccion_comercial/' + this.modificationLocal.id_comercial + '/').then(result => {
        this.modificationLocal = result.data;
        alert('Cancelado con éxito!');
        this.loading = false;
      }, e => {
        this.modificationLocal = {
          'anexo': null,
          'codigo_cnae': null,
          'codigo_municipio_zeus': null,
          'codigo_poblacion_zeus': null,
          'codigo_postal': null,
          'codigo_provincia_zeus': null,
          'codigo_via': null,
          'create_date': null,
          'create_user': 'script reins',
          'direccion_no_estructurada': null,
          'eliminado': false,
          'eliminado_create_date': null,
          'eliminado_create_user': null,
          'eliminado_motivo': null,
          'geom': null,
          'id_categoria_gn_comercial': null,
          'id_comercial': this.modificationLocal.id_comercial,
          'id_precision_coordenada': null,
          'id_tipo_establecimiento_comercial': null,
          'latitud': null,
          'longitud': null,
          'municipio': null,
          'nombre': null,
          'nombre_via': null,
          'numero': null,
          'poblacion': null,
          'provincia': null,
          'resto_direccion': null,
          'tipo_via': null,
          'update_date': null,
          'update_user': null
        };
        alert('Cancelado con éxito!');
        this.loading = false;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/Details/comercial_cambios_identificacion.vue